import React from "react";
type BrandLogoProps = {
  className?: string;
};

/** Logotipo tipográfico de Aura Content. */
export function BrandLogo({
  className = ""
}: BrandLogoProps) {
  return <span className={`inline-flex items-center gap-2 font-display font-semibold uppercase leading-none tracking-[0.28em] ${className}`} data-id="element-51" data-mp="1psxhxw006383">
      <span className="text-cream-50" data-id="element-52" data-mp="1l162ohmarjx9">Aura</span>
      <span className="h-1 w-1 rounded-full bg-caramel-400" aria-hidden="true" data-id="element-53" data-mp="1l0e551953c4c" />
      <span className="text-caramel-400" data-id="element-54" data-mp="1yrsq3dmlxne1">Content</span>
    </span>;
}